<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.color_definition_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.colorCreate"
    sbTooltip="{{ 'lang.globals.colorCreate' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

  Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.headlines.colors' | translate}}"
  [itemsData]="colors"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'colors'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.color' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.description' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
      <th class=" sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-color>

    <tr>
      <td>
        {{ color?.id }}
      </td>
      <td>
        <span [style.backgroundColor]="'#' + color?.color" class="dot mr-1"></span>
        <span [innerHTML]="color?.color"></span>
      </td>
      <td>
        <span [innerHTML]="color?.name | truncate: 60"></span>
      </td>
      <td>
        <span [innerHTML]="color?.description | truncate : 45"></span>
      </td>
      <td>
        <sb-comp-display-modified [data]="color"></sb-comp-display-modified>
      </td>
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="color.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(color, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper-new>

